import { Amplify, type ResourcesConfig } from "aws-amplify";
import { parseAmplifyConfig } from "aws-amplify/utils";
import amplifyOutputs from "../../amplify_outputs.json";
const amplifyConfig = parseAmplifyConfig(amplifyOutputs);

// Configure Amplify with outputs from the Amplify Gen2 deployment
const config: ResourcesConfig = {
    ...amplifyConfig,
    API: {
        ...amplifyConfig.API,
        REST: {
            "Document API": {
                endpoint:
                    "https://c21sus200m.execute-api.eu-west-1.amazonaws.com/",
                region: "eu-west-1",
            },
            "Reporting API": {
                endpoint:
                    "https://n3lox6jdbf.execute-api.eu-west-1.amazonaws.com",
                region: "eu-west-1",
            },
            "User Management API": {
                endpoint:
                    amplifyOutputs.custom.API["User Management API"].endpoint,

                region: amplifyOutputs.custom.API["User Management API"].region,
            },
            // "Receipt Usage API": {
            //     endpoint:
            //         amplifyOutputs.custom.API["Receipt Usage API"].endpoint,

            //     region: amplifyOutputs.custom.API["Receipt Usage API"].region,
            // },
        },
    },
};

Amplify.configure(config);
